import './App.css';
import Banner from './components/Banner';
import Creations from './components/Creations';
import Cta from './components/Cta';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Banner />
      <Cta />
      <Creations/>
      <Footer/>
    </>
  );
}

export default App;
